import { isIE } from 'Utils/browser-info'
import { isMobile } from 'Utils/device'
import { getQueryVariable } from 'Utils/utils';
import store from '@/store/index'

// 插件manifest.json文件配置，必须允许跨域访问
const pluginConfig = (function () {
    return process.env.NODE_ENV === 'development'
    ? [
        'https://webplugins-azk8s.foxitcloud.com/calculator/manifest.json'
    ]
    : [
        'https://webplugins-stgeu.connectedpdf.com/calculator/manifest.json'
    ]
}())

const isCollabURL = () => {
    const reviewSessionID = getQueryVariable('reviewSessionID')
    const fileLink = getQueryVariable('docUrl')
    const fileName = getQueryVariable('fileName')
    return reviewSessionID && fileLink && fileName
}

/**
 * 用于加载默认插件服务(协作模式、ie、移动端不支持)
 */
export default class PluginService {
    constructor () {
        const timer = setInterval(() => {
            if (store && store.viewer && store.viewer.pdfui) {
                clearInterval(timer)
                this.onMounted()
            }
          }, 100)
    }
    onMounted () {
        // return
        if (pluginConfig.length === 0 || isCollabURL() || isIE || isMobile) return 
        for (let index = 0; index < pluginConfig.length; index++) {
            const manifestUrl = pluginConfig[index]
            this.loadPlugin(manifestUrl)
        }
    }
    loadPlugin (manifestUrl) {
        if (!manifestUrl) return 
        const PDFUI = store.viewer.pdfui
        return fetch(manifestUrl).then(res=>res.json()).then(data => {
            const ribbon = data.ribbon
            if (!ribbon) return 
            const tab = ribbon.tabs[0]
            return PDFUI.getComponentByName(`${tab.id}-tab`).then(component => {
                if (!component) return
                const eventName = window.UIExtension.UIConsts.COMPONENT_EVENTS.ACTIVE
                const event = () => {
                    PDFUI.getPluginManager().then(manager => {
                        if (!manager) return
                        manager.loadPluginByObj(data).then(plugin => {
                            plugin.enable()
                        })
                    })
                    component.off(eventName, event)
                }
                component.on(eventName, event)
            })
        })
    }
}